import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const SocketIntegrationsDialog = React.lazy(() => import("./SocketIntegrationsDialog"));

interface SocketIntegrationsDialogLazyPropsType {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function SocketIntegrationsDialogLazy(props: SocketIntegrationsDialogLazyPropsType) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <SocketIntegrationsDialog {...props} />
    </Suspense>
  );
}
